import React from "react";
import { Icon, ff, form, modal, HorizontalLoader } from "@mc/mc-legacy";
import { formValueSelector, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { Row, Col, Button, CardBody, Card, ModalHeader } from "reactstrap";
import "./KontaktyNotifikaceForm.scss";
import OvereniEmailuForm from "./OvereniEmailuForm";
import OvereniTelefonuForm from "./OvereniTelefonuForm";
import {withLang} from "../../i18n/withLang";
import {i18n} from "../../i18n/i18n";

const FormActions = form.FormActions;
const FormBody = form.FormBody;

/**
 * Tento formulář musí být validován ručně zvenčí pomocí této metody, tato metoda pak udělá validaci
 // * @param formData
 * @return {{}}
 */
export const validateKontakty = (data: any) => {
  // Aktuálně není nic povinné
  return {}; //errors;
};

class KontaktyNotifikaceForm extends React.Component<any, { overenyEmail?: string; overenyTelefon?: string }> {
  static formName = "contactForm";
  static defaultProps = {
    canSkip: false,
    onCancel: undefined,
  };

  constructor(props) {
    super(props);
    this.state = {
      overenyEmail: props.initialValues.emailOveren ? props.initialValues.email : undefined,
      overenyTelefon: props.initialValues.telefonOveren ? props.initialValues.telefon : undefined,
    };
  }

  customHandleSubmit = (e, skipSettings) => {
    const { onSubmit, handleSubmit } = this.props;
    handleSubmit((data) => {
      return onSubmit({
        data,
        skipSettings,
      });
    })(e);
  };
  handleChangeTelefon = (e) => {
    const { change } = this.props;
    const { overenyTelefon } = this.state;
    const telefon = e.target.value;

    if (telefon === overenyTelefon) {
      change("telefonOveren", true);
    } else {
      change("telefonOveren", false);
      change("telefonNotifikace", false);
    }
  };
  handleChangeEmail = (e) => {
    const { change } = this.props;
    const { overenyEmail } = this.state;
    const email = e.target.value;

    if (email === overenyEmail) {
      change("emailOveren", true);
    } else {
      change("emailOveren", false);
      change("emailNotifikace", false);
    }
  };
  handleOveritEmail = () => {
    const { dispatch, change, email } = this.props;
    dispatch(
      modal.ModalActions.show(
        OvereniEmailuForm,
        {
          email,
          onSubmit: () => {
            change("emailOveren", true);
            change("emailNotifikace", true);
            this.setState({
              overenyEmail: email,
            });
          },
          onSubmitSuccess: () => {
            dispatch(modal.ModalActions.hide());
          },
        },
          i18n(this.props.lang, "ProfilePage_notificationOvereni"),
        {
          size: "lg",
          modal: true,
        }
      )
    );
  };
  handleOveritTelefon = () => {
    const { dispatch, change, telefon } = this.props;
    dispatch(
      modal.ModalActions.show(
        OvereniTelefonuForm,
        {
          telefon,
          onSubmit: () => {
            change("telefonOveren", true);
            change("telefonNotifikace", true);
            this.setState({
              overenyTelefon: telefon,
            });
          },
          onSubmitSuccess: () => {
            dispatch(modal.ModalActions.hide());
          },
        },
          i18n(this.props.lang, "ProfilePage_notificationOvereni"),
        {
          size: "lg",
          modal: true,
        }
      )
    );
  };

  render() {
    const { submitting, telefonOveren, emailOveren, overovatTelefon, overovatEmail } = this.props;

    const nastaveniEmailNotifikaceDisabled = submitting || !emailOveren;
    const nastaveniTelefonNotifikaceDisabled = submitting || !telefonOveren;

    const handleClose = () => {
      if (this.props.onCancel) {
        this.props.onCancel();
      } else {
        this.props.dispatch(modal.ModalActions.hide());
      }
    };

    return (
      <form.Form className={"kontakty-notifikace-form"}>
        <FormBody>
          <Card className="mb-3">
            <CardBody>
              <Row noGutters className={"m-1 align-items-center"}>
                <Col xs={"auto p-1"}>
                  <Icon className={"kontakt-icon kontakt-email"} icon={"envelope"} />
                </Col>
                <Col xs={1} className={"d-flex justify-content-center relative-checkbox"}>
                  {overovatEmail && (
                    <ff.Checkbox
                      title={emailOveren ? null : i18n(this.props.lang, "ProfilePage_notificationKontaktNotVerified")}
                      label={false}
                      name="emailNotifikace"
                      disabled={nastaveniEmailNotifikaceDisabled}
                    />
                  )}
                </Col>
                <Col className={"p-1"}>
                  <ff.String label={false} name="email" disabled={submitting} onChange={this.handleChangeEmail} />
                </Col>
                <Col xs={"auto p-1 overit-button-action"}>
                    {overovatEmail &&
                        (!emailOveren ? <Button color={"primary"} type={"button"} onClick={this.handleOveritEmail} disabled={submitting}>{i18n(this.props.lang, "ProfilePage_notificationVerify")}</Button> : <span>{i18n(this.props.lang, "ProfilePage_notificationVerified")}</span>)}
                </Col>
              </Row>
              <Row noGutters className={"m-1 align-items-center"}>
                <Col xs={"auto p-1"}>
                  <Icon className={"kontakt-icon kontakt-telefon"} icon={"phone"} />
                </Col>
                <Col xs={1} className={"d-flex justify-content-center relative-checkbox"}>
                  {overovatTelefon && (
                    <ff.Checkbox
                      title={telefonOveren ? null : i18n(this.props.lang, "ProfilePage_notificationKontaktNotVerified")}
                      label={false}
                      name="telefonNotifikace"
                      disabled={nastaveniTelefonNotifikaceDisabled}
                    />
                  )}
                </Col>
                <Col className={"p-1"}>
                  <ff.String label={false} name="telefon" disabled={submitting} onChange={this.handleChangeTelefon} />
                </Col>
                <Col xs={"auto p-1 overit-button-action"}>
                    {overovatTelefon &&
                        (!telefonOveren ? <Button color={"primary"} type={"button"} onClick={this.handleOveritTelefon} disabled={submitting}>{i18n(this.props.lang, "ProfilePage_notificationVerify")}</Button> : <span>{i18n(this.props.lang, "ProfilePage_notificationVerified")}</span>)}
                </Col>
              </Row>
            </CardBody>
          </Card>
        </FormBody>
        <FormActions disabled={submitting} submitButton={false} cancelButton={false} onClose={handleClose}>
          <Row noGutters className={"w-100 mr-2"}>
            <Col className={"text-left my-auto"}>
              {this.props.canSkip && <ff.Checkbox label={i18n(this.props.lang, "ProfilePage_notificationNezobrazovatNotifikace")} name={"nezobrazovatNotifikace"} />}
            </Col>
            <Col xs={"auto"}>
              {this.props.canSkip && (
                <Button type={"submit"} disabled={submitting} onClick={(e) => this.customHandleSubmit(e, true)}>
                    {i18n(this.props.lang, "ProfilePage_notificationSkipSettings")}
                </Button>
              )}
              <Button
                className={"ml-2"}
                color={"primary"}
                type={"submit"}
                disabled={submitting}
                onClick={(e) => this.customHandleSubmit(e, false)}
              >
                  {i18n(this.props.lang, "button_Save")}
                {submitting && <HorizontalLoader />}
              </Button>
            </Col>
          </Row>
        </FormActions>
      </form.Form>
    );
  }
}

function mapStateToProps(state, props) {
  const formName = props.form || KontaktyNotifikaceForm.formName;
  const selector = formValueSelector(formName);
  return {
    telefon: selector(state, "telefon"),
    telefonNotifikace: selector(state, "telefonNotifikace"),
    telefonOveren: selector(state, "telefonOveren"),
    email: selector(state, "email"),
    emailNotifikace: selector(state, "emailNotifikace"),
    emailOveren: selector(state, "emailOveren"),
  };
}

const reduxFormObj = reduxForm<any, any>({
  form: KontaktyNotifikaceForm.formName,
})(KontaktyNotifikaceForm);
export default withLang(connect(mapStateToProps)(reduxFormObj));
